<app-modal-alert
	*ngIf="openAlert"
	[value]="valueModalDelete"
	[nameModal]="nameModal"
	[elementsDelete]="elementsDelete"
	(closeModalAlert)="closeModalAlert($event)"
></app-modal-alert>
<layout-table
	(action)="buttonAction($event)"
	[filterList]="filterList"
	class="h-full"
	[heigth]="254"
	[widthFilter]="660"
	(filterValues)="getFilterValues($event)"
	(filterSelected)="filterSelected($event)"
>
	<button slot="start" class="mg-button btn-add" (click)="openDialogVersion()">
		<mat-icon class="icon-material">add</mat-icon>
		<span>
			{{ translate.buttonVersion }}
		</span>
	</button>
	<app-pagination
		slot="end"
		class="hidden md:block"
		[info]="pagination"
		(emitNavigationPag)="emitNavigation($event)"
	>
	</app-pagination>
	<ngx-datatable
		*ngIf="!isLoading"
		table
		[rows]="version"
		class="fullscreen mg-table"
		[columnMode]="modeColum"
		[headerHeight]="50"
		[footerHeight]="0"
		[rowHeight]="60"
		[limit]="10"
		[rowHeight]="50"
		[messages]="{ emptyMessage: '' }"
		[scrollbarH]="true"
		[scrollbarV]="true"
		[selected]="selected"
		[selectionType]="selectionType.checkbox"
		(select)="onSelect($event)"
		[sorts]="[{ prop: 'name', dir: 'asc' }]"
	>
		<ngx-datatable-column
			[width]="50"
			[sortable]="false"
			[canAutoResize]="false"
			[draggable]="false"
			[resizeable]="false"
		>
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<div class="mng-checkbox">
					<input
						type="checkbox"
						[checked]="allRowsSelected"
						(change)="selectFn(!allRowsSelected)"
					/>
					<span class="checkbox"></span>
				</div>
			</ng-template>
			<ng-template
				ngx-datatable-cell-template
				let-value="value"
				let-isSelected="isSelected"
				let-onCheckboxChangeFn="onCheckboxChangeFn"
			>
				<div class="mng-checkbox">
					<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					<span class="checkbox"></span>
				</div>
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="version" [headerClass]="'text-complementary-color-a font-bold'">
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<span> {{ translate.tableVersion?.version || '' }} </span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template class="text-complementary-color-a">
				V. {{ row?.version }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="date" [headerClass]="'text-complementary-color-a font-bold'">
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<span> {{ translate.tableVersion?.date || '' }} </span>
			</ng-template>
			<ng-template
				let-row="row"
				ngx-datatable-cell-template
				class="font-style: normal; color: #13716B;"
			>
				{{ row?.date | date }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="features" [headerClass]="'text-complementary-color-a font-bold'">
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<span> {{ translate.tableVersion?.features || '' }} </span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template>
				{{ row?.features.length }} {{ translate.tableVersion?.features | lowercase }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column
			name="improvements"
			[headerClass]="'text-complementary-color-a font-bold'"
		>
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<span> {{ translate.tableVersion?.improvements || '' }} </span>
			</ng-template>
			<ng-template let-row="row" ngx-datatable-cell-template>
				{{ row?.improvements.length }} {{ translate.tableVersion?.improvements | lowercase }}
			</ng-template>
		</ngx-datatable-column>
		<ngx-datatable-column name="Actions" [headerClass]="'text-complementary-color-a font-bold'">
			<ng-template
				ngx-datatable-header-template
				let-value="value"
				let-allRowsSelected="allRowsSelected"
				let-selectFn="selectFn"
			>
				<span> {{ translate.tableVersion?.actions || '' }} </span>
			</ng-template>
			<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
				<div class="w-full flex justify-center">
					<app-actions-table
						[optionsTable]="optionsTable"
						[value]="row"
						(action)="actions($event)"
					></app-actions-table>
				</div>
			</ng-template>
		</ngx-datatable-column>
	</ngx-datatable>
	<app-loading-spinner *ngIf="isLoading" loading></app-loading-spinner>
</layout-table>
